/**
 * StyleX styles for admin debug components.
 */

import * as stylex from "@stylexjs/stylex";

import { colors, radius, space } from "@animus/primaris/tokens.stylex";

export const styles = stylex.create({
  statusCard: {
    marginBottom: space.lg,
    borderRadius: radius.lg,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
    backgroundColor: colors.card,
    padding: space.md,
  },
  actionCard: {
    borderRadius: radius.lg,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
    backgroundColor: colors.card,
    padding: space.md,
  },
  actionItem: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    borderRadius: radius.md,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.borderSubtle,
    backgroundColor: colors.muted,
    padding: space.md,
  },
  space: {
    display: "flex",
    flexDirection: "column",
    gap: space.md,
  },
  healthPre: {
    fontFamily: "monospace",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
});
